import React, { FC, memo, useMemo } from "react";

import { AbstractWarning } from "Components/Warning/AbstractWarning";

import {
  ActionButtonContainer,
  ActionButtonStyled,
  CancelButtonStyled,
} from "Components/Warning/styles";

type OverrideMissionWarningProps = {
  vehicleName: string | null;
  handleCloseAction: () => void;
  handleSuccessAction: () => void;
};

const OVERRIDE_MISSION_WARNING_MESSAGE =
  " is actively executing a mission. Overriding the current mission will mark it as complete and any new mission you deploy will immediately begin execution.";

export const OverrideMissionWarning: FC<OverrideMissionWarningProps> = memo(
  ({ vehicleName, handleCloseAction, handleSuccessAction }) => {
    const message = useMemo(
      () => `${vehicleName}${OVERRIDE_MISSION_WARNING_MESSAGE}`,
      [vehicleName]
    );

    const actionHandler = useMemo(() => {
      return (
        <ActionButtonContainer>
          <CancelButtonStyled
            data-test-id="cancel-mission-override-button"
            onClick={() => {
              handleCloseAction();
            }}
          >
            cancel
          </CancelButtonStyled>
          <ActionButtonStyled
            data-test-id="confirm-mission-override-button"
            onClick={() => {
              handleSuccessAction();
            }}
          >
            Override Current Mission
          </ActionButtonStyled>
        </ActionButtonContainer>
      );
    }, []);

    return <AbstractWarning message={message} actionHandler={actionHandler} />;
  }
);
